/**
 * POST User Action
 */
import * as _ from 'lodash-es';
import { Dispatch } from 'redux';
import { track, identifyPublic } from '../../analytics/analytics';

import {
  ACTION_POST_LOGIN_SUCCESS,
  ACTION_POST_LOGIN_FAILURE,
  ACTION_LOGIN_IS_SSO,
  ACTION_LOGIN_IS_PASSWORD,
  ACTION_GET_LOGIN_SUCCESS,
  ACTION_POST_SSO_LOGIN_SUCCESS,
  ACTION_POST_SSO_LOGIN_FAILURE,
  ACTION_LOGOUT_SUCCESS,
  ACTION_REDIRECT_LOGIN,
  RESET_NO_ACCESS,
  API_CALL,
} from '../../configs/ActionTypes';

import { enqueueSnackbarHandler } from '../Status';

/**
 * POST Users Request Action
 */
export function login(email: string, password: string) {
  return (dispatch: Dispatch, getState: Function) => {
    var dataToSend: any = {
      email: email,
      password: password,
    };

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'login',
        method: 'post',
        data: JSON.stringify(dataToSend),
        success: (response: any) => {
          if (response.type === 'error') {
            // Handle error responses - try nested then flat structure
            const errorPayload = _.get(response, 'payload.payload', _.get(response, 'payload', {}));
            if (errorPayload && typeof errorPayload === 'object') {
              enqueueSnackbarHandler(dispatch, errorPayload, 'error');
            }
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          // Defensively handle error object that may not have payload property
          const errorPayload = _.get(error, 'payload', error);
          if (errorPayload && typeof errorPayload === 'object') {
            enqueueSnackbarHandler(dispatch, errorPayload, 'error');
          }
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function getLogin() {
  return (dispatch: Dispatch, getState: Function) => {
    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'auth',
        method: 'get',
        success: (response: any) => {
          if (response.type === 'error') {
            // Handle error responses - try nested then flat structure
            const errorPayload = _.get(response, 'payload.payload', _.get(response, 'payload', {}));
            if (errorPayload && typeof errorPayload === 'object') {
              enqueueSnackbarHandler(dispatch, errorPayload, 'error');
            }
            dispatch(getLoginRequestFailed(response));
          } else {
            dispatch(getLoginRequestSuccess(response));
          }
        },
        fail: (error: any) => {
          // Defensively handle error object that may not have payload property
          const errorPayload = _.get(error, 'payload', error);
          if (errorPayload && typeof errorPayload === 'object') {
            enqueueSnackbarHandler(dispatch, errorPayload, 'error');
          }
          dispatch(getLoginRequestFailed(error));
        },
      },
    });

    return null;
  };
}

export function ssoLogin(email: string) {
  return (dispatch: Dispatch, getState: Function) => {
    var dataToSend: any = {
      email: email,
    };
    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'sso',
        method: 'post',
        data: JSON.stringify(dataToSend),
        success: (response: any) => {
          if (response.type === 'error') {
            // Check if user should use password login instead
            const isPassword = _.get(response, 'payload.isPassword', false);
            if (!isPassword) {
              // Only show error notification if it's NOT an isPassword signal
              const errorPayload = _.get(response, 'payload.payload', _.get(response, 'payload', {}));
              if (errorPayload && typeof errorPayload === 'object') {
                enqueueSnackbarHandler(dispatch, errorPayload, 'error');
              }
            }
            dispatch(ssoRequestFailed(response));
          } else {
            dispatch(ssoRequestSuccess(response));
          }
        },
        fail: (error: any) => {
          // Defensively handle error object that may not have payload property
          const errorPayload = _.get(error, 'payload', error);
          if (errorPayload && typeof errorPayload === 'object') {
            enqueueSnackbarHandler(dispatch, errorPayload, 'error');
          }
          dispatch(ssoRequestFailed(error));
        },
      },
    });

    return null;
  };
}

export function logout() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: ACTION_LOGOUT_SUCCESS,
    });
  };
}

export function resetNoAccess() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: RESET_NO_ACCESS,
    });
  };
}

function requestSuccess(responeJSON: object) {
  identifyPublic(
    _.get(responeJSON, 'payload.user.id', null),
    _.get(responeJSON, 'payload.userRole', null),
  );
  track('BB_AccountLogin', { Status: 'success' });

  return {
    type: ACTION_POST_LOGIN_SUCCESS,
    payload: responeJSON,
  };
}

function ssoRequestSuccess(responseJSON: object) {
  return {
    type: ACTION_POST_SSO_LOGIN_SUCCESS,
    payload: responseJSON,
  };
}

function ssoRequestFailed(responseJSON: object) {
  const isPassword = _.get(responseJSON, 'payload.isPassword', false);
  if (isPassword) {
    return {
      type: ACTION_LOGIN_IS_PASSWORD,
      payload: responseJSON,
    };
  }

  return {
    type: ACTION_POST_SSO_LOGIN_FAILURE,
    payload: responseJSON,
  };
}

function getLoginRequestSuccess(responseJSON: object) {
  identifyPublic(
    _.get(responseJSON, 'payload.user.id', null),
    _.get(responseJSON, 'payload.userRole', null),
  );
  track('BB_AccountLogin', { Status: 'success' });
  return {
    type: ACTION_GET_LOGIN_SUCCESS,
    payload: responseJSON,
  };
}

function getLoginRequestFailed(responseJSON: object) {
  return {
    type: ACTION_REDIRECT_LOGIN,
    payload: responseJSON,
  };
}

function requestFailed(responseJSON: object) {
  track('BB_AccountLogin', { Status: 'failed' });
  const isSso = _.get(responseJSON, 'payload.isSso', false);
  if (isSso) {
    return {
      type: ACTION_LOGIN_IS_SSO,
    };
  }

  return {
    type: ACTION_POST_LOGIN_FAILURE,
    payload: responseJSON,
  };
}

export function setStateToSso() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: ACTION_LOGIN_IS_SSO,
    });
  };
}
